import { useQuery, useQueryClient } from 'react-query'

import { buildMeta } from '~/views/Search/utils/buildMeta'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import { SearchMeta } from '~/models/Search'

interface BuildMetaProps {
  searchParams: any
  item: 'Boats' | 'Caravans'
  metaSearch: any
  pagyCount: string | number
}

const useSearchMeta = ({
  searchParams,
  item,
  metaSearch,
  pagyCount
}: BuildMetaProps) => {
  const queryClient = useQueryClient()

  const mainCategoryQueryParam = searchParams?.by_type
  const subCategoryQueryParam = searchParams?.by_category

  const categories =
    queryClient.getQueryData<SearchMeta[]>('main_categories') ||
    queryClient.getQueryData<SearchMeta[]>('product_categories')

  const chosenCategory = categories?.find(
    ({ name }) => name === mainCategoryQueryParam
  )

  const { data: subCategories } = useQuery(
    ['product_subcategories', searchParams.by_type],
    () =>
      EmpriseGroup.getCategories({ type_name: chosenCategory.name }).then(
        async (resp) => {
          const subcategories = await Deserializer.deserialize(resp)

          return subcategories
        }
      ),
    { enabled: !!searchParams.by_type, refetchOnMount: false }
  )

  const chosenSubCategory =
    subCategoryQueryParam?.length === 1 &&
    subCategories?.find(({ name }) => name === subCategoryQueryParam?.[0])

  const chosenCatDesc = chosenCategory?.description
  const chosenSubCatDesc = chosenSubCategory?.description

  const { meta, title } = buildMeta(searchParams, item, metaSearch, pagyCount)

  const catMetaTitle = chosenCategory?.meta_title
  const subCatMetaTitle = chosenSubCategory?.meta_title

  const catMetaDescription = chosenCategory?.meta_description
  const subCatMetaDescription = chosenSubCategory?.meta_description

  const metaTitle = subCatMetaTitle || catMetaTitle || meta.title
  const metaDescription =
    subCatMetaDescription || catMetaDescription || meta.description

  return {
    metaTitle,
    metaDescription,
    title,
    chosenCatDesc,
    chosenSubCatDesc
  }
}

export default useSearchMeta
